import { create } from 'zustand';

const useConversation = create((set) => ({
  selectedConversation: false,
  setSelectedConversation: (selectedConversation) =>
    set({ selectedConversation }),
  messages: [],
  setMessages: (messages) => set({ messages }),
}));

export { useConversation };
